import { useWatch } from 'react-hook-form';
import { ui } from '@procuros/datachecks';

import { DisplayModes } from 'components/DataTable/Types';

import { FileUploadFieldEdit } from './components/FileUploadFieldEdit';
import { FileUploadFieldView } from './components/FileUploadFieldView';

export type FileUploadValue = {
  file_name: string;
  original_name: string;
  mime_type: string;
} | null;

type FileUploadFieldProps = {
  field: ui.FileUploadField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};

export const FileUploadField = ({ field, fieldId, isReadOnly, mode, variant }: FileUploadFieldProps) => {
  const value = useWatch({ name: fieldId }) as FileUploadValue;

  if (mode === DisplayModes.view) {
    return <FileUploadFieldView field={field} value={value} />;
  }

  return (
    <FileUploadFieldEdit field={field} fieldId={fieldId} isReadOnly={isReadOnly} variant={variant} value={value} />
  );
};
